<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>售后下单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="servcOrder" ref="ruleForm" class="demo-ruleForm">
            <div class="content-caption dashed">
                <span><span class="color-laber"></span>卖家信息</span>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">公司名称</div>
                <div class="content">
                    <div class="pos-rel">{{servcOrder.sellerName}}</div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">联系电话</div>
                <div class="content">
                    <div class="pos-rel">{{servcOrder.sellerContactTel}}</div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">所在地址</div>
                <div class="content">
                    <div class="pos-rel">{{servcOrder.sellerRegionName}}</div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span><span class="color-laber"></span>买家信息</span>
            </div>

            <div class="form-single mt20 mb20">
                <div class="title">零售商名称</div>
                <div class="content">
                    <div class="pos-rel">{{servcOrder.buyerName}}</div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">零售商机构</div>
                <div class="content">
                    <div class="pos-rel">{{servcOrder.buyerShopName}}</div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">机构联系方式</div>
                <div class="content">
                    <div class="pos-rel">{{servcOrder.buyerShopContactTel}}</div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">零售商机构地址</div>
                <div class="content">
                    <div class="pos-rel">{{servcOrder.buyerShopAddr}}</div>
                </div>
            </div>


            <div class="content-caption dashed">
                <span><span class="color-laber"></span>服务项信息</span>
            </div>
            <div v-if="servcOrder.servcOrderItem != null">
                <div class="form-single mt20 mb20">
                    <div class="title">服务项</div>
                    <div class="content">
                        <div class="pos-rel">{{servcOrder.servcOrderItem.title}}</div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">上次完成时间</div>
                    <div class="content">
                        <div class="pos-rel">{{servcOrder.servcOrderItem.finishTime}}</div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">质保期</div>
                    <div class="content">
                        <div class="pos-rel">{{servcOrder.servcOrderItem.wrntPeriod}}</div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">质保到期时间</div>
                    <div class="content">
                        <div class="pos-rel">{{servcOrder.servcOrderItem.wrntDueTime}}</div>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span><span class="color-laber"></span>选择预约时间</span>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">预约时间</div>
                <div class="content">
                    <div class="pos-rel">
                        <el-date-picker v-model="planTime" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm"></el-date-picker>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span><span class="color-laber"></span>留言</span>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">留言板</div>
                <div class="content">
                    <div class="pos-rel">
                        <textarea class="width-2x" placeholder="请输入..." v-model="servcOrder.postscript"></textarea>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="form-toolbar align-center" style="padding: 0;">
            <button class="swb-btn" @click="submitClick">提交</button>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcOrderApi from '../../api/servcOrder'

    import SwbAfterSaleOrderList from './AfterSaleOrderList';
    Routes.add(SwbAfterSaleOrderList);

    export default {
        name: 'swb-after-sale-order-create',
        path: '/after/sale/order/create',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '创建服务售后订单',
        data: function () {
            return {
                servcOrder: {},
                servcOrderItemList: [],
                planTime: new Date(),
            }
        },
        created: function () {
            let self = this;
            let orderId = this.$route.query.orderId || null;
            let orderItemId = this.$route.query.orderItemId || null;
            //
            self.getServcOrder(orderId, orderItemId);
        },
        methods: {
            getServcOrder: function (orderId, orderItemId) {
                let self = this;
                let postData = {};
                postData.orderId = orderId;
                postData.orderItemId = orderItemId;
                let loading = MsgBox.loading();
                servcOrderApi.getServcOrderInfoByIdAndItemId(postData, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let servcOrder = result.data;
                        servcOrder.postscript = null;
                        self.servcOrder = servcOrder;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //提交订单
            submitClick: function () {
                let self = this;
                if(!Utils.isNoB(self.planTime)) {
                    let servcOrder = self.servcOrder;
                    let saleOrder = {};
                    let saleOrderItem = {};
                    saleOrder.planTime = self.planTime.format("yyyy-MM-dd HH:mm");
//                    let planTimeFromAndTo = self.planTimeFromAndTo;
//                    saleOrder.planTimeFrom = planTimeFromAndTo[0].format("HH:mm:ss");
//                    saleOrder.planTimeTo = planTimeFromAndTo[1].format("HH:mm:ss");
                    saleOrder.afterSaleFlag = true;
                    saleOrder.afterSaleSrcOrderId = servcOrder.id;
                    saleOrder.afterSaleSrcOrderNo = servcOrder.no;
                    saleOrder.postscript = servcOrder.postscript;
                    saleOrder.proxied = false;
                    saleOrder.submitted = true;
                    saleOrderItem.id = servcOrder.servcOrderItem.id;
                    self.servcOrderItemList.push(saleOrderItem);
                    saleOrder.itemList = self.servcOrderItemList;
                    let postData = saleOrder;
                    let lastMsgBoxDlg = MsgBox.loading();
                    servcOrderApi.saveServcOrderAfterSale(postData, function (reault) {
                        if(reault.type == 'info') {
                            setTimeout(function () {
                                lastMsgBoxDlg.close();
                                self.returnAfterSaleOrder();
                                MsgBox.success("保存成功");
                            }, 3000);
                        } else {
                            lastMsgBoxDlg.close();
                            MsgBox.warning("保存失败");
                        }
                    });
                } else {
                    MsgBox.warning("预约时间不能为空");
                }
            },
            returnAfterSaleOrder: function () {
                this.$router.push({
                    path: SwbAfterSaleOrderList.path,
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/servcOrder/AfterSaleOrderCreate.vue